import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/theme/liga-logo-white.png'
import _imports_1 from '@/theme/user.png'


const _hoisted_1 = { class: "menu-notification-flag" }
const _hoisted_2 = { class: "menu-notification-flag" }
const _hoisted_3 = { class: "menu-header-background menu-header menu-header-modern" }
const _hoisted_4 = {
  key: 0,
  class: "menu-header-profile-row"
}
const _hoisted_5 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_6 = { class: "menu-header-profile-text" }
const _hoisted_7 = {
  key: 1,
  class: "menu-header-guest-actions"
}
const _hoisted_8 = { class: "menu-footer-links" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "menu-footer-payee" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "menu-header-background menu-header menu-header-modern menu-header-offline" }
const _hoisted_13 = { class: "menu-header-profile-row" }
const _hoisted_14 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_15 = { class: "menu-header-profile-text" }
const _hoisted_16 = { class: "menu-footer-links" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "menu-footer-payee" }
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 0,
  ref: "audioRef",
  preload: "metadata"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "w-player" }
const _hoisted_23 = { class: "w-track-name" }
const _hoisted_24 = { class: "w-playlist-name" }
const _hoisted_25 = { class: "w-player-range" }
const _hoisted_26 = { class: "player-label player-current-time" }
const _hoisted_27 = { class: "player-label player-total-time" }
const _hoisted_28 = { class: "w-player-buttons" }
const _hoisted_29 = { class: "w-service-player-buttons" }
const _hoisted_30 = { class: "w-full-player" }
const _hoisted_31 = { class: "w-full-player-header" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "playlist-header-text-wrapper" }
const _hoisted_34 = { class: "orange-regular" }
const _hoisted_35 = { class: "playlist-play-button-wrapper" }
const _hoisted_36 = { class: "w-full-player-range" }
const _hoisted_37 = { class: "player-label playlist-current-time" }
const _hoisted_38 = { class: "player-label playlist-total-time" }
const _hoisted_39 = { class: "player-range player-playlist-range" }
const _hoisted_40 = { class: "micro-player" }
const _hoisted_41 = { class: "micro-track-time" }
const _hoisted_42 = { class: "micro-player-controls" }
const _hoisted_43 = { class: "micro-player-buttons" }
const _hoisted_44 = { class: "player-range micro-range" }
const _hoisted_45 = { class: "tab-icon-wrapper" }
const _hoisted_46 = { class: "tab-icon-wrapper" }
const _hoisted_47 = { class: "tab-icon-wrapper" }
const _hoisted_48 = { class: "tab-icon-wrapper" }
const _hoisted_49 = { class: "tab-icon-wrapper" }
const _hoisted_50 = { class: "tab-icon-wrapper" }
const _hoisted_51 = { class: "tab-icon-wrapper" }
const _hoisted_52 = { class: "liga-loading-container" }
const _hoisted_53 = ["src"]
const _hoisted_54 = ["href"]
const _hoisted_55 = { class: "support-channel-grid" }
const _hoisted_56 = { class: "support-channel-icon-wrap" }
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "support-channel-icon-wrap" }
const _hoisted_59 = ["src"]
const _hoisted_60 = { class: "support-channel-icon-wrap support-channel-icon-wrap--wide" }
const _hoisted_61 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_vue_slider = _resolveComponent("vue-slider")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_tab_button = _resolveComponent("ion-tab-button")!
  const _component_ion_tab_bar = _resolveComponent("ion-tab-bar")!
  const _component_ion_tabs = _resolveComponent("ion-tabs")!
  const _component_ion_toast = _resolveComponent("ion-toast")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_ion_fab, {
        horizontal: _ctx.menuButton.position === 'left' ? 'start' : 'end',
        vertical: "top",
        slot: "fixed"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_fab_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openMenu())),
            class: "menu-fab-button"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
                [_vShow, _ctx.globalContext.showMenuNotification && _ctx.menuButton.position !== 'left'
          ]
              ]),
              _createVNode(_component_ion_icon, {
                icon: _ctx.menuOutline,
                class: "app-icon"
              }, null, 8, ["icon"]),
              _withDirectives(_createElementVNode("div", _hoisted_2, null, 512), [
                [_vShow, _ctx.globalContext.showMenuNotification && _ctx.menuButton.position == 'left'
          ]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["horizontal"]), [
        [_vShow, _ctx.showMainMenuFab]
      ]),
      _createVNode(_component_ion_menu, {
        contentId: "main",
        menuId: "mainMenu",
        side: _ctx.menuButton.position === 'left' ? 'start' : 'end',
        type: "overlay",
        "swipe-gesture": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[86] || (_cache[86] = _createElementVNode("div", { class: "menu-header-brand" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Лига",
                class: "menu-header-logo-img"
              })
            ], -1)),
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_ion_avatar, { class: "menu-header-avatar" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_ion_img, { src: _ctx.avatarUrl }, null, 8, ["src"]), [
                        [_vShow, _ctx.avatarUrl !== '']
                      ]),
                      _withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [
                        [_vShow, _ctx.avatarUrl == '']
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_ion_label, { class: "menu-header-user-label" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.userFirstname) + " " + _toDisplayString(_ctx.userLastname), 1)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("button", {
                      type: "button",
                      class: "menu-header-profile-link",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate('account')))
                    }, [
                      _cache[84] || (_cache[84] = _createTextVNode(" Профиль ", -1)),
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.chevronForwardOutline,
                        class: "menu-header-profile-chevron",
                        "aria-hidden": "true"
                      }, null, 8, ["icon"])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    class: "menu-header-login-btn",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('login')))
                  }, {
                    default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                      _createTextVNode("Вход", -1)
                    ]))]),
                    _: 1
                  })
                ]))
          ]),
          _createVNode(_component_ion_content, { class: "menu-content" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, { class: "menu-list" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigate('today'))),
                    class: _normalizeClass([_ctx.isToday ? 'selected-route' : '', 'menu-item'])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.todayOutline,
                        class: "app-icon"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu-label" }, {
                        default: _withCtx(() => [...(_cache[87] || (_cache[87] = [
                          _createTextVNode("Сегодня", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 0,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigate('programs'))),
                        class: _normalizeClass([_ctx.isPrograms ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.fileTrayFullOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                              _createTextVNode("Релизы от Лиги", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 1,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigate('music-library'))),
                        class: _normalizeClass([_ctx.isMusicLibrary ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.discOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[89] || (_cache[89] = [
                              _createTextVNode("Музыка", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 2,
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigate('playlist-list'))),
                        class: _normalizeClass([_ctx.isPlaylistList ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.musicalNotesOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[90] || (_cache[90] = [
                              _createTextVNode("Миксы", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 3,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigate('skills'))),
                        class: _normalizeClass([_ctx.isSkills ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.schoolOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                              _createTextVNode("Тренинги", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuthenticated && !_ctx.globalContext.offlineMode)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 4,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.navigate('testing'))),
                        class: _normalizeClass([_ctx.isTesting ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.documentTextOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[92] || (_cache[92] = [
                              _createTextVNode("Тестирование", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 5,
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.navigate('events'))),
                        class: _normalizeClass([_ctx.isEvents ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.calendarOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[93] || (_cache[93] = [
                              _createTextVNode("События", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 6,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.navigate('useful-links'))),
                        class: _normalizeClass([_ctx.isUsefulLinks ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.linkOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[94] || (_cache[94] = [
                              _createTextVNode("Полезные ссылки", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 7,
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.navigate('my-tickets'))),
                        class: _normalizeClass([_ctx.isMyTickets ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.ticketOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[95] || (_cache[95] = [
                              _createTextVNode("Мои билеты", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && _ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item_divider, { key: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { class: "menu-section-label" }, {
                            default: _withCtx(() => [...(_cache[96] || (_cache[96] = [
                              _createTextVNode("Администрирование", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && _ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 9,
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.navigate('users'))),
                        class: _normalizeClass([_ctx.isUsers ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.peopleOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[97] || (_cache[97] = [
                              _createTextVNode("Пользователи", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && _ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 10,
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.navigate('admin-roles'))),
                        class: _normalizeClass([_ctx.isAdminRoles ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.keyOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                              _createTextVNode("Роли", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && _ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 11,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.navigate('admin-education-sections'))),
                        class: _normalizeClass([_ctx.isAdminEducationSections ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.libraryOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[99] || (_cache[99] = [
                              _createTextVNode("Разделы тренингов", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && _ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 12,
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.navigate('admin-media-upload'))),
                        class: _normalizeClass([_ctx.isAdminMediaUpload ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.cloudUploadOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[100] || (_cache[100] = [
                              _createTextVNode("Медиатека", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && _ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 13,
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.navigate('admin-releases'))),
                        class: _normalizeClass([_ctx.isAdminReleases ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.fileTrayFullOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                              _createTextVNode("Релизы", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && _ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 14,
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.navigate('admin-library-music'))),
                        class: _normalizeClass([_ctx.isAdminLibraryMusic ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.discOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[102] || (_cache[102] = [
                              _createTextVNode("Каталог музыки", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && _ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 15,
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.navigate('admin-payments'))),
                        class: _normalizeClass([_ctx.isAdminPayments ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.cardOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[103] || (_cache[103] = [
                              _createTextVNode("Оплаты", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && _ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 16,
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.navigate('admin-push-broadcast'))),
                        class: _normalizeClass([_ctx.isAdminPushBroadcast ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.notificationsOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[104] || (_cache[104] = [
                              _createTextVNode("Push-рассылка", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && _ctx.isAuthenticated)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 17,
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.navigate('admin-useful-links'))),
                        class: _normalizeClass([_ctx.isAdminUsefulLinks ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.linkOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                              _createTextVNode("Полезные ссылки (админ)", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MANAGER']) && _ctx.isAuthenticated && !_ctx.globalContext.offlineMode)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 18,
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.navigate('admin-testing'))),
                        class: _normalizeClass([_ctx.isAdminTesting ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.documentTextOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[106] || (_cache[106] = [
                              _createTextVNode("Тестирование", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (!_ctx.globalContext.offlineMode)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 19,
                        onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.openSupportChannelMenu())),
                        class: "menu-item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.helpOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[107] || (_cache[107] = [
                              _createTextVNode("Техподдержка", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_item, {
                    onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.navigate('settings'))),
                    class: _normalizeClass([_ctx.isSettings ? 'selected-route' : '', 'menu-item'])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.settingsOutline,
                        class: "app-icon"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu-label" }, {
                        default: _withCtx(() => [...(_cache[108] || (_cache[108] = [
                          _createTextVNode("Настройки", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_footer, { class: "menu-footer" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, {
                translucent: "",
                class: "app-footer-style"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("a", {
                      href: _ctx.LEGAL.offerUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "menu-footer-link"
                    }, "Оферта", 8, _hoisted_9),
                    _cache[109] || (_cache[109] = _createElementVNode("span", { class: "menu-footer-sep" }, "|", -1)),
                    _createElementVNode("span", {
                      onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.navigate('privacy-policy'))),
                      class: "menu-footer-link"
                    }, "Конфиденциальность"),
                    _cache[110] || (_cache[110] = _createElementVNode("span", { class: "menu-footer-sep" }, "|", -1)),
                    _createElementVNode("span", {
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.navigate('offer-supplement'))),
                      class: "menu-footer-link"
                    }, "Возвраты")
                  ]),
                  _createElementVNode("p", _hoisted_10, [
                    _cache[111] || (_cache[111] = _createTextVNode("Платежи принимает: ", -1)),
                    _createElementVNode("a", {
                      href: _ctx.LEGAL.offerUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "menu-footer-link"
                    }, _toDisplayString(_ctx.LEGAL.payeeShortName), 9, _hoisted_11)
                  ]),
                  _createVNode(_component_ion_title, {
                    class: "ion-text-center menu-footer menu-footer-version",
                    onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.checkAppUpdate()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Версия " + _toDisplayString(_ctx.appVersion), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["side"]),
      _createVNode(_component_ion_menu, {
        contentId: "main",
        menuId: "offlineMenu",
        side: _ctx.menuButton.position === 'left' ? 'start' : 'end',
        type: "overlay",
        "swipe-gesture": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _cache[113] || (_cache[113] = _createElementVNode("div", { class: "menu-header-brand" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "Лига",
                class: "menu-header-logo-img"
              })
            ], -1)),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_ion_avatar, { class: "menu-header-avatar" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_ion_img, { src: _ctx.avatarUrl }, null, 8, ["src"]), [
                    [_vShow, _ctx.avatarUrl !== '']
                  ]),
                  _withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [
                    [_vShow, _ctx.avatarUrl == '']
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_ion_label, { class: "menu-header-user-label" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.userFirstname) + " " + _toDisplayString(_ctx.userLastname), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("button", {
                  type: "button",
                  class: "menu-header-profile-link",
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.navigate('account')))
                }, [
                  _cache[112] || (_cache[112] = _createTextVNode(" Профиль ", -1)),
                  _createVNode(_component_ion_icon, {
                    icon: _ctx.chevronForwardOutline,
                    class: "menu-header-profile-chevron",
                    "aria-hidden": "true"
                  }, null, 8, ["icon"])
                ])
              ])
            ])
          ]),
          _createVNode(_component_ion_content, { class: "menu-content" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_list, { class: "menu-list" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, {
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.navigate('today'))),
                    class: _normalizeClass([_ctx.isToday ? 'selected-route' : '', 'menu-item'])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.todayOutline,
                        class: "app-icon"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu-label" }, {
                        default: _withCtx(() => [...(_cache[114] || (_cache[114] = [
                          _createTextVNode("Сегодня", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_ion_item, {
                    onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.navigate('programs'))),
                    class: _normalizeClass([_ctx.isPrograms ? 'selected-route' : '', 'menu-item'])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.fileTrayFullOutline,
                        class: "app-icon"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu-label" }, {
                        default: _withCtx(() => [...(_cache[115] || (_cache[115] = [
                          _createTextVNode("Релизы от Лиги", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_ion_item, {
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.navigate('music-library'))),
                    class: _normalizeClass([_ctx.isMusicLibrary ? 'selected-route' : '', 'menu-item'])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.discOutline,
                        class: "app-icon"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu-label" }, {
                        default: _withCtx(() => [...(_cache[116] || (_cache[116] = [
                          _createTextVNode("Музыка", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_ion_item, {
                    onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.navigate('playlist-list'))),
                    class: _normalizeClass([_ctx.isPlaylistList ? 'selected-route' : '', 'menu-item'])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.musicalNotesOutline,
                        class: "app-icon"
                      }, null, 8, ["icon"]),
                      _createVNode(_component_ion_label, { class: "menu-label" }, {
                        default: _withCtx(() => [...(_cache[117] || (_cache[117] = [
                          _createTextVNode("Миксы", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  (_ctx.isMobile)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 0,
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.navigate('skills'))),
                        class: _normalizeClass([_ctx.isSkills ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.schoolOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[118] || (_cache[118] = [
                              _createTextVNode("Тренинги", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (_ctx.isMobile && !_ctx.globalContext.offlineMode)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 1,
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.navigate('testing'))),
                        class: _normalizeClass([_ctx.isTesting ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.documentTextOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[119] || (_cache[119] = [
                              _createTextVNode("Тестирование", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true),
                  (!_ctx.globalContext.offlineMode)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 2,
                        onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.openSupportChannelMenu())),
                        class: "menu-item"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.helpOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[120] || (_cache[120] = [
                              _createTextVNode("Техподдержка", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isMobile)
                    ? (_openBlock(), _createBlock(_component_ion_item, {
                        key: 3,
                        onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.navigate('settings'))),
                        class: _normalizeClass([_ctx.isSettings ? 'selected-route' : '', 'menu-item'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.settingsOutline,
                            class: "app-icon"
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_label, { class: "menu-label" }, {
                            default: _withCtx(() => [...(_cache[121] || (_cache[121] = [
                              _createTextVNode("Настройки", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["class"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_footer, { class: "menu-footer" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, {
                translucent: "",
                class: "app-footer-style"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("a", {
                      href: _ctx.LEGAL.offerUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "menu-footer-link"
                    }, "Оферта", 8, _hoisted_17),
                    _cache[122] || (_cache[122] = _createElementVNode("span", { class: "menu-footer-sep" }, "|", -1)),
                    _createElementVNode("span", {
                      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.navigate('privacy-policy'))),
                      class: "menu-footer-link"
                    }, "Конфиденциальность"),
                    _cache[123] || (_cache[123] = _createElementVNode("span", { class: "menu-footer-sep" }, "|", -1)),
                    _createElementVNode("span", {
                      onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.navigate('offer-supplement'))),
                      class: "menu-footer-link"
                    }, "Возвраты")
                  ]),
                  _createElementVNode("p", _hoisted_18, [
                    _cache[124] || (_cache[124] = _createTextVNode("Платежи принимает: ", -1)),
                    _createElementVNode("a", {
                      href: _ctx.LEGAL.offerUrl,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      class: "menu-footer-link"
                    }, _toDisplayString(_ctx.LEGAL.payeeShortName), 9, _hoisted_19)
                  ]),
                  _createVNode(_component_ion_title, { class: "ion-text-center menu-footer menu-footer-version" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Версия " + _toDisplayString(_ctx.appVersion), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["side"]),
      _createVNode(_component_ion_tabs, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_router_outlet, { id: "main" }),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(['music-player-container', !_ctx.showReleaseTabs() && !_ctx.showTodayTabs() ? 'music-player-bottom-container' : ''])
          }, [
            (!_ctx.isMobile)
              ? (_openBlock(), _createElementBlock("audio", _hoisted_20, [
                  _createElementVNode("source", {
                    src: _ctx.trackPath,
                    type: "audio/mpeg"
                  }, null, 8, _hoisted_21)
                ], 512))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.playerBar.currentTrackIdx !== undefined &&
              _ctx.playerBar.musicList !== undefined &&
              _ctx.playerBar.musicList[_ctx.playerBar.currentTrackIdx] !== undefined
              ? _ctx.mediaUtils.getTrackName(
                _ctx.playerBar.musicList[_ctx.playerBar.currentTrackIdx]
              )
              : ""), 1),
              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.playerBar.playlistName), 1),
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_vue_slider, {
                  lazy: true,
                  modelValue: _ctx.playerBar.currentPosition,
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.playerBar.currentPosition) = $event)),
                  min: 0,
                  max: _ctx.playerBar.currentDuration,
                  onDragging: _ctx.rangeDragging,
                  onDragStart: _cache[39] || (_cache[39] = ($event: any) => (_ctx.rangeDragStart())),
                  onDragEnd: _cache[40] || (_cache[40] = ($event: any) => (_ctx.rangeDragEnd())),
                  tooltip: "none",
                  "drag-on-click": true
                }, null, 8, ["modelValue", "max", "onDragging"])
              ]),
              _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.playerBar.currentTrackCurrentTime), 1),
              _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.playerBar.musicList && _ctx.playerBar.musicList.length > 0
              ? _ctx.mediaUtils.formatTime(
                _ctx.playerBar.musicList[_ctx.playerBar.currentTrackIdx].duration -
                _ctx.playerBar.currentPosition
              )
              : "--:--"), 1),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(_component_ion_button, {
                  class: "player-button player-extended-sm-button",
                  disabled: _ctx.isFM(),
                  onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.prevAudioTrack()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      icon: _ctx.playSkipBack,
                      class: "player-button-icon"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_ion_button, {
                  class: "player-button player-extended-sm-button",
                  disabled: _ctx.isFM(),
                  onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.playBackTrack()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      icon: _ctx.playBack,
                      class: "player-button-icon"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_ion_button, {
                  class: "player-button",
                  onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.changeCurrentPosition(-15)))
                }, {
                  default: _withCtx(() => [...(_cache[125] || (_cache[125] = [
                    _createTextVNode(" -15 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  class: "player-button player-extended-l-button",
                  slot: "end",
                  onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.playerControls(!_ctx.playerBar.playing)))
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.play,
                      class: "player-button-icon"
                    }, null, 8, ["icon"]), [
                      [_vShow, !_ctx.playerBar.playing && (!_ctx.isMobile || _ctx.playerBar.isReady)]
                    ]),
                    _withDirectives(_createVNode(_component_ion_icon, {
                      icon: _ctx.pause,
                      class: "player-button-icon"
                    }, null, 8, ["icon"]), [
                      [_vShow, _ctx.playerBar.playing && (!_ctx.isMobile || _ctx.playerBar.isReady)]
                    ]),
                    _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                      [_vShow, _ctx.isMobile && !_ctx.playerBar.isReady]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  class: "player-button",
                  onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.changeCurrentPosition(15)))
                }, {
                  default: _withCtx(() => [...(_cache[126] || (_cache[126] = [
                    _createTextVNode(" +15 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_button, {
                  class: "player-button player-extended-sm-button",
                  onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.nextAudioTrack()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      icon: _ctx.playSkipForward,
                      class: "player-button-icon"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_ion_button, {
                  class: "player-button",
                  onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.extendPlayerOnTrackName())),
                  disabled: _ctx.isFM()
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      icon: _ctx.menuOutline,
                      class: "player-button-icon"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _withDirectives(_createVNode(_component_ion_button, {
                  class: "player-button",
                  onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.toMicroMode()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      icon: _ctx.contractOutline,
                      class: "player-button-icon"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, false]
                ]),
                _createVNode(_component_ion_button, {
                  class: "player-button",
                  onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.closePlayer()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, {
                      icon: _ctx.closeOutline,
                      class: "player-button-icon"
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, !_ctx.showPlayList]
            ]),
            _createVNode(_Transition, { name: "playlist-player" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_ion_button, {
                      class: "playlist-collapse-button",
                      onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.toExtendedPlayer()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.chevronDownOutline,
                          class: "player-button-icon"
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }),
                    (_ctx.playerBar.fixedAlbumArtUrl || (_ctx.playerBar.playlistImage && '' !== _ctx.playerBar.playlistImage)
                )
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.playerAlbumImage
                        }, null, 8, _hoisted_32))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.playerBar.musicList.length) + " Треков · " + _toDisplayString(_ctx.mediaUtils.formatTime(
                      _ctx.mediaUtils.getTotalPlaylistDuration(_ctx.playerBar.musicList)
                    )) + " / ", 1),
                        _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.mediaUtils.formatTime(
                      _ctx.mediaUtils.getTotalPlaylistDurationFromIndex(
                        _ctx.playerBar.musicList,
                        _ctx.playerBar.currentTrackIdx
                      ) - _ctx.playerBar.currentPosition
                    )), 1)
                      ]),
                      _createElementVNode("h1", null, _toDisplayString(_ctx.playerBar.currentTrackIdx !== undefined &&
                    _ctx.playerBar.musicList !== undefined &&
                    _ctx.playerBar.musicList[_ctx.playerBar.currentTrackIdx] !==
                    undefined
                    ? _ctx.mediaUtils.getTrackNameShort(
                      _ctx.playerBar.musicList[_ctx.playerBar.currentTrackIdx]
                    )
                    : ""), 1),
                      _createElementVNode("h3", null, _toDisplayString(_ctx.playerBar.playlistName), 1),
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_ion_button, {
                          class: "playlist-play-button",
                          onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.playerControls(!_ctx.playerBar.playing)))
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createVNode(_component_ion_icon, {
                              icon: _ctx.play,
                              class: "player-button-icon"
                            }, null, 8, ["icon"]), [
                              [_vShow, !_ctx.playerBar.playing && _ctx.playerBar.isReady]
                            ]),
                            _withDirectives(_createVNode(_component_ion_icon, {
                              icon: _ctx.pause,
                              class: "player-button-icon"
                            }, null, 8, ["icon"]), [
                              [_vShow, _ctx.playerBar.playing && _ctx.playerBar.isReady]
                            ]),
                            _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                              [_vShow, !_ctx.playerBar.isReady]
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          class: "playlist-play-button playlist-play-button-sm",
                          onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.prevAudioTrack()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.playSkipBack,
                              class: "player-button-icon"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }),
                        false
                          ? (_openBlock(), _createBlock(_component_ion_button, {
                              key: 0,
                              class: "playlist-play-button playlist-play-button-sm",
                              onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.playBackTrack()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  icon: _ctx.playBack,
                                  class: "player-button-icon"
                                }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_button, {
                          class: "playlist-play-button playlist-play-button-sm",
                          onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.nextAudioTrack()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.playSkipForward,
                              class: "player-button-icon"
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.playerBar.currentTrackCurrentTime), 1),
                    _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.playerBar.musicList && _ctx.playerBar.musicList.length > 0
                      ? _ctx.mediaUtils.formatTime(
                          _ctx.playerBar.musicList[_ctx.playerBar.currentTrackIdx]
                              .duration - _ctx.playerBar.currentPosition
                      )
                      : "--:--"), 1),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_vue_slider, {
                        lazy: true,
                        modelValue: _ctx.playerBar.currentPosition,
                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.playerBar.currentPosition) = $event)),
                        min: 0,
                        max: _ctx.playerBar.currentDuration,
                        onDragging: _ctx.rangeDragging,
                        onDragStart: _cache[56] || (_cache[56] = ($event: any) => (_ctx.rangeDragStart())),
                        onDragEnd: _cache[57] || (_cache[57] = ($event: any) => (_ctx.rangeDragEnd())),
                        tooltip: "none",
                        "drag-on-click": true
                      }, null, 8, ["modelValue", "max", "onDragging"])
                    ])
                  ]),
                  _createVNode(_component_ion_list, {
                    class: "player-playlist",
                    lines: "none"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playerBar.musicList, (audioTrack, idx) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: audioTrack.id,
                          onClick: ($event: any) => (_ctx.selectTrackAndPlay(idx)),
                          class: "player-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, {
                              class: _normalizeClass([
                  _ctx.playerBar.currentTrackIdx === idx ? 'selected-track' : '',
                  'playlist-label',
                ])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.mediaUtils.getTrackNameShort(audioTrack)), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"]),
                            _createVNode(_component_ion_note, {
                              class: _normalizeClass([
                  _ctx.playerBar.currentTrackIdx === idx ? 'selected-track' : '',
                ]),
                              slot: "end"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.mediaUtils.formatTime(audioTrack.duration)), 1)
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, {
                    class: "fake-footer bg-transparent",
                    lines: "none"
                  })
                ], 512), [
                  [_vShow, _ctx.showPlayList && !_ctx.isFM()]
                ])
              ]),
              _: 1
            })
          ], 2), [
            [_vShow, _ctx.playerBar.visible && !_ctx.playerBar.microMode]
          ]),
          _withDirectives(_createElementVNode("div", {
            class: _normalizeClass(['micro-player-container', _ctx.playerBar.microExtendedMode ? 'micro-player-container-ext' : ''])
          }, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", {
                class: _normalizeClass(['w-track-index', _ctx.playerBar.microExtendedMode ? 'w-track-index-ext' : '']),
                onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.playerBar.microExtendedMode = !_ctx.playerBar.microExtendedMode))
              }, [
                _createTextVNode(_toDisplayString(_ctx.playerBar.currentTrackIdx + 1) + " ", 1),
                _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.playerBar.currentTrackCurrentTime), 1)
              ], 2),
              _withDirectives(_createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_ion_button, {
                    class: "player-button player-extended-sm-button",
                    disabled: _ctx.isFM(),
                    onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.prevAudioTrack()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.playSkipBack,
                        class: "player-button-icon"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_ion_button, {
                    class: "player-button player-extended-sm-button",
                    disabled: _ctx.isFM(),
                    onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.playBackTrack()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.playBack,
                        class: "player-button-icon"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_ion_button, {
                    class: "player-button",
                    onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.changeCurrentPosition(-15)))
                  }, {
                    default: _withCtx(() => [...(_cache[127] || (_cache[127] = [
                      _createTextVNode(" -15 ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    class: "player-button player-extended-l-button",
                    slot: "end",
                    onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.playerControls(!_ctx.playerBar.playing)))
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_ion_icon, {
                        icon: _ctx.play,
                        class: "player-button-icon"
                      }, null, 8, ["icon"]), [
                        [_vShow, !_ctx.playerBar.playing && (!_ctx.isMobile || _ctx.playerBar.isReady)]
                      ]),
                      _withDirectives(_createVNode(_component_ion_icon, {
                        icon: _ctx.pause,
                        class: "player-button-icon"
                      }, null, 8, ["icon"]), [
                        [_vShow, _ctx.playerBar.playing && (!_ctx.isMobile || _ctx.playerBar.isReady)]
                      ]),
                      _withDirectives(_createVNode(_component_ion_spinner, { name: "bubbles" }, null, 512), [
                        [_vShow, _ctx.isMobile && !_ctx.playerBar.isReady]
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    class: "player-button",
                    onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.changeCurrentPosition(15)))
                  }, {
                    default: _withCtx(() => [...(_cache[128] || (_cache[128] = [
                      _createTextVNode(" +15 ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    class: "player-button player-extended-sm-button",
                    onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.nextAudioTrack()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        icon: _ctx.playSkipForward,
                        class: "player-button-icon"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ])
              ], 512), [
                [_vShow, _ctx.playerBar.microExtendedMode]
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_component_vue_slider, {
                  lazy: true,
                  modelValue: _ctx.playerBar.currentPosition,
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.playerBar.currentPosition) = $event)),
                  min: 0,
                  max: _ctx.playerBar.currentDuration,
                  onDragging: _ctx.rangeDragging,
                  onDragStart: _cache[66] || (_cache[66] = ($event: any) => (_ctx.rangeDragStart())),
                  onDragEnd: _cache[67] || (_cache[67] = ($event: any) => (_ctx.rangeDragEnd())),
                  tooltip: "none",
                  "drag-on-click": true,
                  dotSize: _ctx.playerBar.microExtendedMode ? 8 : 5
                }, null, 8, ["modelValue", "max", "onDragging", "dotSize"])
              ])
            ])
          ], 2), [
            [_vShow, _ctx.playerBar.microMode && _ctx.playerBar.musicList.length > 0]
          ]),
          _createVNode(_component_ion_modal, {
            ref: "playNowModal",
            onDidDismiss: _cache[72] || (_cache[72] = () => {
          _ctx.showPlayNow = false;
        }
        ),
            "can-dismiss": true,
            breakpoints: [0.5, 0.8, 1],
            initialBreakpoint: 0.5,
            "is-open": _ctx.showPlayNow,
            handle: false,
            class: "play-now-container"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.playNowNavigate('programs')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [...(_cache[129] || (_cache[129] = [
                            _createTextVNode("Релизы от Лиги", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_ion_button, {
                      onClick: _cache[69] || (_cache[69] = ($event: any) => (_ctx.playNowNavigate('playlist-list')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [...(_cache[130] || (_cache[130] = [
                            _createTextVNode("Миксы", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.isMobile]
                    ]),
                    _createVNode(_component_ion_button, {
                      disabled: _ctx.playerBar.musicList.length < 1,
                      onClick: _cache[70] || (_cache[70] = ($event: any) => (_ctx.playNow()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Сейчас: " + _toDisplayString(_ctx.playerBar.playlistName.length > 0 ? _ctx.playerBar.playlistName : "-"), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_ion_button, {
                      onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.showPlayNow = false)),
                      class: "cancel-button"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [...(_cache[131] || (_cache[131] = [
                            _createTextVNode(" Закрыть ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["is-open"]),
          _withDirectives(_createVNode(_component_ion_tab_bar, {
            slot: "bottom",
            class: _normalizeClass(["modern-tab-bar", { 'tab-bar-web': !_ctx.isMobile }])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_tab_button, {
                class: "modern-tab-button",
                onClick: _cache[73] || (_cache[73] = ($event: any) => (_ctx.navigate('Programs')))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_ion_icon, { icon: _ctx.fileTrayFullOutline }, null, 8, ["icon"])
                  ]),
                  _cache[132] || (_cache[132] = _createElementVNode("span", { class: "tab-label" }, "Назад", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "music",
                href: "/music",
                target: "release-router",
                class: "modern-tab-button"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_ion_icon, { icon: _ctx.musicalNotesOutline }, null, 8, ["icon"])
                  ]),
                  _cache[133] || (_cache[133] = _createElementVNode("span", { class: "tab-label" }, "Музыка", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "video",
                href: "/video",
                target: "release-router",
                class: "modern-tab-button"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_47, [
                    _createVNode(_component_ion_icon, { icon: _ctx.filmOutline }, null, 8, ["icon"])
                  ]),
                  _cache[134] || (_cache[134] = _createElementVNode("span", { class: "tab-label" }, "Видео", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_tab_button, {
                tab: "guide",
                href: "/guide",
                target: "release-router",
                class: "modern-tab-button"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_ion_icon, { icon: _ctx.documentOutline }, null, 8, ["icon"])
                  ]),
                  _cache[135] || (_cache[135] = _createElementVNode("span", { class: "tab-label" }, "Гайды", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"]), [
            [_vShow, _ctx.showReleaseTabs()]
          ]),
          (_ctx.isAuthenticated)
            ? _withDirectives((_openBlock(), _createBlock(_component_ion_tab_bar, {
                key: 0,
                slot: "bottom",
                class: _normalizeClass(["modern-tab-bar", { 'tab-bar-web': !_ctx.isMobile }])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_tab_button, {
                    tab: "workouts",
                    href: "/programs",
                    target: "today-router",
                    class: _normalizeClass([{ selected: _ctx.isActive('workouts') }, 'modern-tab-button'])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_ion_icon, { icon: _ctx.listOutline }, null, 8, ["icon"])
                      ]),
                      _cache[136] || (_cache[136] = _createElementVNode("span", { class: "tab-label" }, "Программы", -1))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_ion_tab_button, {
                    tab: "playlists",
                    href: "/playlist-list",
                    target: "today-router",
                    class: _normalizeClass([{ selected: _ctx.isActive('playlists') }, 'modern-tab-button'])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(_component_ion_icon, { icon: _ctx.playOutline }, null, 8, ["icon"])
                      ]),
                      _cache[137] || (_cache[137] = _createElementVNode("span", { class: "tab-label" }, "Миксы", -1))
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_ion_tab_button, {
                    tab: "skills",
                    href: "/skills",
                    target: "today-router",
                    class: _normalizeClass([{ selected: _ctx.isActive('skills') }, 'modern-tab-button'])
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_ion_icon, { icon: _ctx.schoolOutline }, null, 8, ["icon"])
                      ]),
                      _cache[138] || (_cache[138] = _createElementVNode("span", { class: "tab-label" }, "Тренинги", -1))
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }, 8, ["class"])), [
                [_vShow, _ctx.showTodayTabs()]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_toast, {
        cssClass: "custom-toast",
        "is-open": _ctx.lostNetwork,
        message: "Пропал интернет. Переходим в оффлайн.",
        duration: 1200,
        position: "middle",
        color: "dark",
        onDidDismiss: _cache[74] || (_cache[74] = ($event: any) => (_ctx.openNetworkToast(false)))
      }, null, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        "css-class": "liga-modal-loading",
        "is-open": _ctx.globalContext.isLoading,
        backdropDismiss: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("div", {
              class: "liga-loading-go-offline",
              onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.goOfflineAndStopLoading()))
            }, [
              _createVNode(_component_ion_icon, { icon: _ctx.cloudOffline }, null, 8, ["icon"])
            ]),
            _cache[139] || (_cache[139] = _createElementVNode("p", { class: "liga-loading-header" }, "Загрузка", -1)),
            _createElementVNode("img", {
              src: require(`@/theme/liga-logo-black.png`),
              alt: "loading image"
            }, null, 8, _hoisted_53),
            _cache[140] || (_cache[140] = _createElementVNode("p", { class: "liga-loading-header" }, "ПОГОДИ, ЩА ВСЕ БУДЕТ", -1)),
            _createVNode(_component_ion_spinner, { name: "bubbles" })
          ])
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.showPrivacyConsentModal,
        "backdrop-dismiss": false,
        class: "privacy-consent-modal",
        onDidDismiss: _cache[78] || (_cache[78] = ($event: any) => (_ctx.showPrivacyConsentModal = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [...(_cache[141] || (_cache[141] = [
                      _createTextVNode("Согласие с условиями", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _cache[143] || (_cache[143] = _createElementVNode("p", { class: "privacy-consent-text" }, " Национальная лига тренеров обрабатывает ваши персональные данные в соответствии с Политикой конфиденциальности и Договором оферты. Продолжая использовать приложение, вы подтверждаете согласие с этими документами. ", -1)),
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[76] || (_cache[76] = _withModifiers(($event: any) => (_ctx.openPrivacyPolicy()), ["prevent"])),
                  class: "privacy-consent-link"
                }, "Политика конфиденциальности")
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  href: _ctx.privacyOfferUrl,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "privacy-consent-link"
                }, "Договор оферты", 8, _hoisted_54)
              ]),
              _createVNode(_component_ion_button, {
                expand: "block",
                class: "privacy-consent-accept-btn",
                onClick: _cache[77] || (_cache[77] = ($event: any) => (_ctx.acceptPrivacyConsent()))
              }, {
                default: _withCtx(() => [...(_cache[142] || (_cache[142] = [
                  _createTextVNode(" Принимаю ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.showSupportChannelModal,
        class: "support-channel-modal",
        onDidDismiss: _cache[83] || (_cache[83] = ($event: any) => (_ctx.showSupportChannelModal = false))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, null, {
                    default: _withCtx(() => [...(_cache[144] || (_cache[144] = [
                      _createTextVNode("Техподдержка", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_buttons, { slot: "end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        fill: "clear",
                        onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.showSupportChannelModal = false))
                      }, {
                        default: _withCtx(() => [...(_cache[145] || (_cache[145] = [
                          _createTextVNode("Закрыть", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_content, { class: "ion-padding support-channel-content" }, {
            default: _withCtx(() => [
              _cache[149] || (_cache[149] = _createElementVNode("p", { class: "support-channel-hint ion-text-center" }, "Выберите мессенджер", -1)),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("button", {
                  type: "button",
                  class: "support-channel-btn",
                  onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.openExternalSupportChannel(_ctx.supportTelegramUrl)))
                }, [
                  _createElementVNode("span", _hoisted_56, [
                    _createElementVNode("img", {
                      src: _ctx.supportTelegramIcon,
                      alt: "",
                      width: "48",
                      height: "48",
                      decoding: "async"
                    }, null, 8, _hoisted_57)
                  ]),
                  _cache[146] || (_cache[146] = _createElementVNode("span", { class: "support-channel-label" }, "Telegram", -1))
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "support-channel-btn",
                  onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.openExternalSupportChannel(_ctx.supportVkUrl)))
                }, [
                  _createElementVNode("span", _hoisted_58, [
                    _createElementVNode("img", {
                      src: _ctx.supportVkIcon,
                      alt: "",
                      width: "48",
                      height: "48",
                      decoding: "async"
                    }, null, 8, _hoisted_59)
                  ]),
                  _cache[147] || (_cache[147] = _createElementVNode("span", { class: "support-channel-label" }, "VK", -1))
                ]),
                (_ctx.supportBlueskyUrl)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "support-channel-btn",
                      onClick: _cache[82] || (_cache[82] = ($event: any) => (_ctx.openExternalSupportChannel(_ctx.supportBlueskyUrl)))
                    }, [
                      _createElementVNode("span", _hoisted_60, [
                        _createElementVNode("img", {
                          src: _ctx.supportBlueskyIcon,
                          alt: "",
                          width: "48",
                          height: "48",
                          decoding: "async"
                        }, null, 8, _hoisted_61)
                      ]),
                      _cache[148] || (_cache[148] = _createElementVNode("span", { class: "support-channel-label" }, "Bluesky", -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"])
    ]),
    _: 1
  }))
}